import {ParamsModel} from 'src/app/modules/common/Model'
import {DeleteCSRRateModel, CSRRateModel} from '../Model'
import {actionTypes} from './constants'

export const actions = {
  // get CsrRate DATA
  getCsrRate: (params: ParamsModel = {page: 1, limit: 10}) => ({
    type: actionTypes.GET_CSR_RATE_START,
    payload: params,
  }),
  getCsrRateSuccess: (data: CSRRateModel) => ({
    type: actionTypes.GET_CSR_RATE_SUCCESS,
    payload: data,
  }),
  getCsrRateFinish: () => ({
    type: actionTypes.GET_CSR_RATE_FINISH,
  }),

  // create CsrRate
  addCsrRate: (data: CSRRateModel | any) => ({
    type: actionTypes.ADD_CSR_RATE_START,
    payload: data,
  }),
  addCsrRateSuccess: (task: any) => ({
    type: actionTypes.ADD_CSR_RATE_SUCCESS,
    payload: task,
  }),
  addCsrRateFinish: () => ({
    type: actionTypes.ADD_CSR_RATE_FINISH,
  }),
  resetCsrRate: () => ({
    type: actionTypes.RESET_CSR_RATE_TYPE,
  }),

  //Update CsrRate
  updateCsrRate: (data: CSRRateModel | any, id: string) => ({
    type: actionTypes.UPDATE_CSR_RATE_START,
    payload: data,
    id,
  }),

  updateCsrRateSuccess: (data: CSRRateModel) => ({
    type: actionTypes.UPDATE_CSR_RATE_SUCCESS,
    payload: data,
  }),

  updateCsrRateFinish: () => ({
    type: actionTypes.UPDATE_CSR_RATE_FINISH,
  }),

  // delete CsrRate
  deleteCsrRate: (data: DeleteCSRRateModel[]) => ({
    type: actionTypes.DELETE_CSR_RATE_START,
    payload: {csrReportId: data},
  }),
  deleteCsrRateSuccess: (data: any) => ({
    type: actionTypes.DELETE_CSR_RATE_SUCCESS,
    payload: data,
  }),
  deleteCsrRateFinish: () => ({
    type: actionTypes.DELETE_CSR_RATE_FINISH,
  }),

  //Enable CsrRate
  enableCsrRate: (data: any) => ({
    type: actionTypes.ENABLE_CSR_RATE_REQUEST,
    payload: {data},
  }),

  enableCsrRateSuccess: (task: any) => ({
    type: actionTypes.ENABLE_CSR_RATE_SUCCESS,
    payload: task,
  }),
  enableCsrRateFinish: () => ({
    type: actionTypes.ENABLE_CSR_RATE_FINISH,
  }),

  //Disable CsrRate
  disableCsrRate: (data: any) => ({
    type: actionTypes.DISABLE_CSR_RATE_REQUEST,
    payload: {data},
  }),

  disableCsrRateSuccess: (task: any) => ({
    type: actionTypes.DISABLE_CSR_RATE_SUCCESS,
    payload: task,
  }),
  disableCsrRateFinish: () => ({
    type: actionTypes.DISABLE_CSR_RATE_FINISH,
  }),

  //Single Enable CsrRate
  singleEnableCsrRate: (data: any) => ({
    type: actionTypes.SINGLE_ENABLE_CSR_RATE_REQUEST,
    payload: {data},
  }),

  singleEnableCsrRateSuccess: (task: any) => ({
    type: actionTypes.SINGLE_ENABLE_CSR_RATE_SUCCESS,
    payload: task,
  }),
  singleEnableCsrRateFinish: () => ({
    type: actionTypes.SINGLE_ENABLE_CSR_RATE_FINISH,
  }),

  //Single Disable CsrRate
  singleDisableCsrRate: (data: any) => ({
    type: actionTypes.SINGLE_DISABLE_CSR_RATE_REQUEST,
    payload: {data},
  }),

  singleDisableCsrRateSuccess: (task: any) => ({
    type: actionTypes.SINGLE_DISABLE_CSR_RATE_SUCCESS,
    payload: task,
  }),
  singleDisableCsrRateFinish: () => ({
    type: actionTypes.SINGLE_DISABLE_CSR_RATE_FINISH,
  }),
}
